/* eslint-disable ember/use-ember-data-rfc-395-imports */
import { Configuration, StatusApi, type StatusApiListDevicesRequest } from '@envoy/devices_client';
import type DS from 'ember-data';
import type { ModelSchema } from 'ember-data';
import { type ModelRegistry } from 'ember-data/model';
import ApplicationAdapter from 'garaje/adapters/application';
import config from 'garaje/config/environment';
import { Promise as EmberPromise } from 'rsvp';

export default class DeviceStatusAdapter extends ApplicationAdapter {
  host = config.devicesHost;

  query<K extends keyof ModelRegistry>(
    _store: DS.Store,
    _type: ModelSchema<K>,
    query: Record<string, unknown>,
  ): EmberPromise<Record<string, unknown>> {
    const locationId = this.extractLocationId(query);
    const statusApi = this.buildStatusApi();

    if (!locationId) {
      throw new Error('device-status query requires a location_id');
    }

    const statusApiRequest = this.buildStatusApiRequest({ query, locationId });
    return new EmberPromise((resolve, reject) => {
      statusApi
        .listDevices(statusApiRequest)
        .then(({ data }) => {
          resolve(data as unknown as Record<string, unknown>);
        })
        .catch(reject);
    });
  }

  private extractLocationId(query: Record<string, unknown>): string | null {
    const locationId = typeof query['location_id'] === 'string' ? query['location_id'] : query['locationId'];

    if (typeof locationId === 'string' && locationId.length > 0) {
      return locationId;
    }

    return null;
  }

  private buildStatusApi(): StatusApi {
    const statusApiConfiguration = new Configuration({
      basePath: this.host,
      baseOptions: {
        withCredentials: true,
      },
    });

    return new StatusApi(statusApiConfiguration, this.host);
  }

  private buildStatusApiRequest({
    query,
    locationId,
  }: {
    query: Record<string, unknown>;
    locationId: string;
  }): StatusApiListDevicesRequest {
    const rawLimit = query['limit'];
    const normalizedLimit = typeof rawLimit === 'string' ? Number(rawLimit) : rawLimit;

    return {
      locationId,
      ...(typeof query['product'] === 'string' ? { product: query['product'] } : {}),
      ...(typeof normalizedLimit === 'number' && !Number.isNaN(normalizedLimit)
        ? { limit: normalizedLimit }
        : typeof rawLimit === 'number'
          ? { limit: rawLimit }
          : {}),
    } as StatusApiListDevicesRequest;
  }
}
